import { render, staticRenderFns } from "./cart-item-list.vue?vue&type=template&id=95f08c90&scoped=true&"
import script from "./cart-item-list.vue?vue&type=script&lang=js&"
export * from "./cart-item-list.vue?vue&type=script&lang=js&"
import style0 from "./cart-item-list.vue?vue&type=style&index=0&id=95f08c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f08c90",
  null
  
)

export default component.exports